import getPreviewPaneViewState from '../selectors/getPreviewPaneViewState';

/**
 *
 * @returns Returns the sub path for attachment preview pane if preview pane store is not null
 */
export const getAttachmentPreviewSubRoute = (): string[] => {
    const viewState = getPreviewPaneViewState();
    if (viewState?.attachmentId) {
        return ['attachment', viewState.attachmentId];
    } else {
        return [];
    }
};
